/**
 * @voltxampere/ui — PlaceCommand (Sprint 13)
 *
 * Add a single ComponentInstance to a circuit. Used by StampTool
 * when the user clicks the canvas to drop a sembol.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class PlaceCommand {
    component;
    constructor(component) {
        this.component = component;
    }
    do(circuit) {
        return { ...circuit, components: [...circuit.components, this.component] };
    }
    undo(circuit) {
        return {
            ...circuit,
            components: circuit.components.filter((c) => c.id !== this.component.id),
        };
    }
    describe() {
        return `Yerleştirildi: ${this.component.type}`;
    }
}
//# sourceMappingURL=place.js.map